export type ColorIndicator = string

export const PREVIOUS_COLORS: Partial<Record<ColorIndicator, string>> = {
  brown: '#a3643a',
  peach: '#ff7f50',
  indigo: '#4951d6',
  navy: '#004080',
  sky: '#46c3f9',
  mint: '#7fffd0',
  pink: '#ff4f87',
  charcoal: '#555d66',
  rave: '#e3ffe9',
  wheat: '#ede8dd',
  marine: '#7fffd0',
}
export const ACTIVE_COLORS: Partial<Record<ColorIndicator, string>> = {
  green: '#4fd299',
  yellow: '#f0d000',
  orange: '#ff9869',
  red: '#e8503d',
  purple: '#d095ff',
  forest: '#228b22',
  olive: '#9cab2d',
  umber: '#a3643a',
  maroon: '#800000',
  imperial: '#643a71',
  lime: '#47e58d',
  cyan: '#4e98ff',
  teal: '#008080',
  magenta: '#ff45ca', // aka disco-pop
  gray: '#aab1bd',
  folk: '#3d5b01',
  blue: '#006eb7',
  richblue: '#070bff',
  classic: '#910460',
  taupe: '#483c32',
}
export const COLORS: Partial<Record<ColorIndicator, string>> = {
  ...PREVIOUS_COLORS,
  ...ACTIVE_COLORS,
}
